module.exports = __webpack_public_path__ + "static/img/story08.bf7753e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/story/story08.jpg
// module id = O5oc
// module chunks = 1